import React from 'react';
import { Link } from 'react-router-dom';

const COPY = {
  en: {
    eyebrow: 'START HERE',
    title: 'Start with a Business Systems Audit.',
    body: 'Every engagement begins with clarity. The audit gives us a shared view of the operation so the next step is the right one.',
  },
  es: {
    eyebrow: 'COMIENZA AQUÍ',
    title: 'Comienza con una Auditoría de Sistemas de Negocio.',
    body: 'Cada compromiso comienza con claridad. La auditoría nos da una visión compartida de la operación para que el siguiente paso sea el correcto.',
  },
};

/**
 * AuditCTABannerV2 — reusable audit CTA. Every service page links here.
 * Accepts an optional custom CTA label; defaults to the service's own label
 * when provided by the caller.
 */
const AuditCTABannerV2 = ({ lang = 'en', ctaLabel }) => {
  const t = COPY[lang] || COPY.en;
  const label = ctaLabel || (lang === 'es' ? 'Solicita tu auditoría' : 'Request your audit');
  return (
    <section className="iv2-audit-cta-banner" data-testid="iv2-audit-cta-banner">
      <div className="iv2-container iv2-audit-cta-banner-inner">
        <div>
          <p className="iv2-section-eyebrow">{t.eyebrow}</p>
          <h2 className="iv2-audit-cta-banner-title">{t.title}</h2>
          <p className="iv2-audit-cta-banner-body">{t.body}</p>
        </div>
        <Link
          to={`/v2/audit?lang=${lang}`}
          className="iv2-btn iv2-btn-primary iv2-audit-cta-banner-btn"
          data-testid="iv2-audit-cta-banner-btn"
        >
          {label}
        </Link>
      </div>
    </section>
  );
};

export default AuditCTABannerV2;
